<template>
  <div>
    <div v-if="loading">
      <b-row>
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
      </b-col>
    </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col md="12">
          <component-new-header
            title="Customer Management"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push(`/customer-management`)"
          />
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col
            ><b-row
              ><b-col>
                <h3>
                  {{ details && details.name ? details.name.first : "" }}
                </h3>
                <h5 class="mt-4">
                  <img :src="`img/User.png`" class="mr-2 icon-height" />
                  <h5 style="margin-top: -15px; margin-left: 28px">
                    {{ details ? details.customerNo : "" }}
                  </h5>
                </h5>
              </b-col>
            </b-row></b-col
          >
          <b-col class="mt-2">
            <div>
              <img :src="`img/Email.png`" class="icon-height" />
              <h5 style="margin-top: -16px; margin-left: 33px">
                {{ (contactList[1] && contactList[1].email) || "" }}
              </h5>
              <h5 style="margin-top: 28px">
                <img :src="`img/Phone.png`" class="mr-2 mb-1 icon-height" />
                {{ (contactList[0] && contactList[0].phone) || "" }}
              </h5>
            </div>
          </b-col>
          <b-col v-if="details" class="mt-2">
            <template v-for="(address, index) in details.addresses">
              <div
                :key="index"
                v-if="address.isDefault == true"
                style="margin-left: 33px"
              >
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5
                  style="display: inline; position: absolute; margin-top: 0px"
                >
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
              <div
                :key="index"
                v-if="
                  details.addresses.length == 1 && address.isDefault == false
                "
                style="margin-top: 28px"
              >
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5
                  style="display: inline; position: absolute; margin-top: 0px"
                >
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
            </template>
          </b-col>
          <b-col class="ml-auto">
            <b-button
              v-if="
                this.$currentUserData.category === 'DISTRIBUTOR' ||
                this.$currentUserData.category === 'DEALER' ||
                this.$currentUserData.category === 'SUB_DEALER'
              "
              variant="primary"
              @click="
                $router.push({
                  name: 'raise-service-request',
                  params: {
                    customerData: details,
                    id: details._id,
                    customerId: currentUser.id,
                  },
                })
              "
              style="width: 158px"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> New Service
              Request</b-button
            >
          </b-col>
        </b-row>
      </b-card>
      <b-tabs v-model="tabIndex" pills lazy>
        <b-tab>
          <template #title>
            <strong>Order</strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              orderCount || 0
            }}</b-button>
          </template>
          <order></order>
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Address Management </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              addressCount || 0
            }}</b-button>
          </template>
          <addressManagement />
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Service Request </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              serviceRequestCount || 0
            }}</b-button>
          </template>
          <serviceRequest />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ComponentNewHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-simple-suggest/dist/styles.css";
import order from "./order.vue";
import addressManagement from "./addressManagement.vue";
import serviceRequest from "./serviceRequest.vue";
import { AtomSpinner } from "epic-spinners";
import awardBenefits from "./awardBenefits.vue";
import raiseServiceRequestVue from "./raiseServiceRequest.vue";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  components: {
    VueSimpleSuggest,
    ComponentNewHeader,
    order,
    addressManagement,
    serviceRequest,
    awardBenefits,
    ebSelect,
    raiseServiceRequestVue,
    loader,
    AtomSpinner,
  },
  data() {
    return {
      tabIndex: 0,
      influencer: false,
      currentUser: "",
      details: "",
      search: "",
      referralDetails: "",
      refererId: "",
      direct: 0,
      group: 0,
      loading: false,
      contactList: [],
    };
  },
  computed: {
    ...mapGetters({
      getOrderCount: "customerManagement/GetOrderGraph",
      getServiceRequestCount: "customerManagement/GetServiceTicketList",
    }),
    orderCount() {
      const dataList = this.getOrderCount;
      if (
        dataList &&
        dataList.response &&
        Array.isArray(dataList.response) &&
        dataList.response.length &&
        dataList.response[0].totalCount
      ) {
        return dataList && dataList.response[0]
          ? dataList.response[0].totalCount
          : 0;
      }
    },
    addressCount() {
      let addressList = this.details?.addresses?.length || "";
      return addressList;
    },
    serviceRequestCount() {
      const dataList = this.getServiceRequestCount;
      if (
        dataList &&
        dataList.data &&
        dataList.data.data &&
        Array.isArray(dataList.data.data) &&
        dataList.data.data.length
      ) {
        return dataList && dataList.data ? dataList.data.data.length : 0;
      }
    },
    getCustomerDetails() {
      return this.$store.getters["customerManagement/GetCustomerDetails"];
    },
  },
  methods: {
    getDeliveryContact() {
      let x = this.details?.addresses ? this.details.addresses : [];
      if (x.length == 0) {
        this.contactList.push({
          phone: this.currentUser?.userData?.authentication?.phone || "",
        });
        this.contactList.push({
          email: this.currentUser?.userData?.authentication?.email || "",
        });
      } else {
        let mainAddress = x[0];
        x.forEach((address) => {
          if (address.isDefault == true) {
            mainAddress = address;
          }
        });
        mainAddress.contacts.forEach((contact) => {
          if (contact.contactType == "PRIMARY_PHONE") {
            this.contactList.push({ phone: contact.value });
          }
          if (contact.contactType == "PRIMARY_EMAIL") {
            this.contactList.push({ email: contact.value });
          }
        });
      }
    },
    async fetchCustomerDetails() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/customerDetails",
        payload
      );
      this.details = data;
      this.getDeliveryContact();
      this.refererId = this.details?.metaInfo
        ? this.details.metaInfo.refererId
        : "";
      if (this.refererId) {
        const payload = {
          id: this.refererId,
        };
        const data = await this.$store.dispatch(
          "customerManagement/customerDetails",
          payload
        );
        return (this.referralDetails = data);
      }
      return (this.details = data);
    },
  },
  async mounted() {
    this.currentUser = this.$route.params;
    this.loading= true;
    await this.fetchCustomerDetails();
    this.loading= false;
  },
};
</script>

<style>
.text-grey {
  color: #aaaa;
  background-color: transparent;
}

.btn-dark {
  border-radius: 65%;
  margin-left: 40px;
  height: 28px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--primary);
  background-color: #fff;
  outline-color: black !important;
}
.tap-top2 {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  color: white;
  text-align: center;
  background: green;
  border: none;
  font-size: 25px;
  padding: 2px;
  cursor: pointer;
  float: right;
  margin-top: 14px;
  margin-right: 88px;
}
.icon-height {
  height: 18px;
}
.referrals-header .card-header {
  background: var(--primary);
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.referrals-header {
  width: 47%;
}
.customerDetails {
  height: auto;
  width: auto;
}
.nav-link.active {
  border: 1px solid #e7c4c4;
  border-bottom: 0px;
  border-radius: 5px 5px 0px 0px;
}
</style>
